import React, { useContext } from 'react';
import HeaderContext from './HeaderContext';
import HeaderFlyoutItem from './HeaderFlyoutItem';
import HeaderFlyoutMegaMenu from './HeaderFlyoutMegaMenu';
import HeaderFlyoutLocale from './HeaderFlyoutLocale';

const HeaderFlyout = ({ children, id }) => {
  const { activeFlyout } = useContext(HeaderContext);

  return (
    <div
      className={`c-header-mega-menu ${activeFlyout === id ? 'is-open' : ''}`}
    >
      <div className="u-hide@desktop">
        <ul className="o-list-bare  c-header-nav__list">{children}</ul>
      </div>
    </div>
  );
};

export default HeaderFlyout;

HeaderFlyout.Item = HeaderFlyoutItem;
HeaderFlyout.Locale = HeaderFlyoutLocale;
HeaderFlyout.MegaMenu = HeaderFlyoutMegaMenu;
